export class CustomerModel {
    Id: number;
    AccountNumber: number;

    FirstName: string;
    LastName: string;
    Email: string;
    Phone: string;
    IsVendor: boolean;

    AddressLine1: string;
    AddressLine2: string;
    Suburb: string;
    State: string;
    Postcode: string;
    Country: string;

    ShippingAddressLine1: string;
    ShippingAddressLine2: string;
    ShippingSuburb: string;
    ShippingState: string;
    ShippingPostcode: string;
    ShippingCountry: string;

    BuyerPremium: number;
    VendorPremium: number;

    ExternalId: string;

    constructor() {
        this.FirstName = "";
        this.LastName = "";
        this.Email = "";
        this.Phone = "";
        this.IsVendor = false;
        this.AddressLine1 = "";
        this.AddressLine2 = "";
        this.Suburb = "";
        this.State = "";
        this.Postcode = "";
        this.Country = "";
        this.ShippingAddressLine1 = "";
        this.ShippingAddressLine2 = "";
        this.ShippingSuburb = "";
        this.ShippingState = "";
        this.ShippingPostcode = "";
        this.ShippingCountry = "";
    }
}